import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  AppInfoIcon,
  ArrowIcon,
  ExitIcon
  // ThemeIcon
} from "../../Assets/assets";
import defaultFace from "../../Assets/face/defaultFace.svg";
import Button from "../../Components/Button/Button";
import Header from "../../Components/Header/Header";
import Modal from "../../Components/Modal/Modal";
import {
  logout
  //  setTheme
} from "../../Redux/authentication/actions";
import { alignPhoneNumber } from "../../Utils/constants";
import { setSuccessStatus } from "../../Redux/status/action";

function Profile(props) {
  const [modal, setModal] = useState({
    logout: false,
    clearCache: false
  });
  const [activeDropdown, setActiveDropdown] = useState(null);
  const settingsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownClick = (section) => {
    if (activeDropdown === section) {
      setActiveDropdown(null);
    } else if (activeDropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(section);
    }
  };

  const clearSiteCache = async () => {
    localStorage.clear();
    sessionStorage.clear();

    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let reg of registrations) {
        await reg.unregister();
      }
    }

    logout();

    setSuccessStatus(
      "Cache cleared successfully. Please log in again to continue."
    );
    window.location.reload();
  };

  return (
    <div className="inherit-parent-height inherit-parent-width">
      <Header
        theme={props.auth.theme.primaryColor === "#0E0E0E" ? "dark" : "light"}
        title="Profile"
        backOnClick={() => {
          props.navigate(-1);
        }}
      />
      <div className="inherit-parent-height flex-justify-content-space-between flex-direction-column">
        <div className="remaining-body-height inherit-parent-width display-flex flex-justify-content-center overflow-x-scroll hide-scrollbar padding-large">
          <div className="inherit-parent-height inherit-parent-width max-width-767px flex-direction-column">
            <div className="display-flex inherit-parent-width">
              <div
                style={{
                  width: "60px",
                  height: "62px"
                }}
              >
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                  }}
                  src={props.profile.data?.profilePictureUrl || defaultFace}
                  alt="profile-picture"
                />
              </div>
              <div className="display-flex flex-direction-column padding-left-larger font-color-secondaryColor">
                <div className="text-capitalize font-color-tertiaryColor">
                  {props.profile?.data?.name}
                </div>
                <div className="font-size-medium font-color-tertiaryColor">
                  {alignPhoneNumber(props.profile?.data?.phoneNumber)}
                </div>
                <div className="text-uppercase font-size-small">
                  {props.profile?.data?.type}
                </div>
              </div>
            </div>
            <div className="display-flex flex-direction-column padding-top-larger">
              {/* <SectionDropdown
                title="Themes"
                isOpen={activeDropdown === "themes"}
                onClick={() => handleDropdownClick("themes")}
                icon={<ThemeIcon color="var(--tertiaryColor6)" />}
                blur={activeDropdown && activeDropdown !== "themes"}
              >
                <ThemesContainer
                  onThemeClick={(data) => {
                    setTheme(data);
                  }}
                  selectedTheme={props.auth.theme}
                />
              </SectionDropdown> */}

              <SectionDropdown
                title={`App version ${
                  process.env.REACT_APP_BUILD_NUM?.toString() || "1.0.o"
                }`}
                isOpen={activeDropdown === "version"}
                onClick={() => handleDropdownClick("version")}
                icon={<AppInfoIcon color="var(--tertiaryColor6)" />}
                blur={activeDropdown && activeDropdown !== "version"}
              >
                <div className="padding-left-large padding-top-default">
                  <div
                    data-cy="CLEAR-CACHE-BUTTON"
                    onClick={() => {
                      setModal({ logout: false, clearCache: true });
                    }}
                    className="font-size-small display-flex flex-justify-content-space-between"
                  >
                    <div>Clear Cache</div>
                    <ArrowIcon color="var(--tertiaryColor6)" />
                  </div>
                </div>
              </SectionDropdown>

              <div
                data-cy="LOGOUT-BUTTON"
                onClick={() => {
                  setModal({ logout: true, clearCache: false });
                }}
                style={{
                  padding: "12px 12px 12px 12px"
                }}
                className="display-flex padding-right-default flex-align-items-center"
              >
                <div style={{ width: "20px", height: "20px" }}>
                  <ExitIcon height="18px" width="18px" color="#D0405A" />
                </div>
                <div
                  style={{
                    color: "#D0405A"
                  }}
                  className="margin-left-medium font-color-tertiaryColor6 font-size-small"
                >
                  Logout
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={modal.logout}
        canIgnore={true}
        onClose={() => {
          setModal({ ...modal, logout: false });
        }}
        width="inherit-parent-width"
        position="absolute-center-self-horizontally bottom-0 "
        maxWidth="none"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-fit-to-content"
      >
        <section
          data-cy="LOGOUT-CONFIRM-MODAL"
          className="font-color-tertiaryColor6 font-color-secondary text-align-center padding-larger background-color-primary"
        >
          <div className="font-size-medium">LOGOUT</div>
          <div className="padding-top-default font-color-tertiaryColor5 font-size-small">
            Are you sure to logout from the application?
          </div>

          <section className="display-flex padding-top-larger ">
            <Button
              boxShadow={false}
              type="submit"
              variant="danger"
              text="Yes"
              className="border-1px-e5e5e5 margin-right-small"
              onClick={() => {
                logout();
              }}
              data-cy="CONFIRM-LOGOUT-BUTTON"
            />
            <Button
              boxShadow={false}
              text="No"
              variant="transparent"
              onClick={() => {
                setModal({ ...modal, logout: false });
              }}
              className="padding-left-large padding-right-large"
              data-cy="CANCEL-LOGOUT-BUTTON"
            />
          </section>
        </section>
      </Modal>

      <Modal
        show={modal.clearCache}
        canIgnore={true}
        onClose={() => {
          setModal({ ...modal, clearCache: false });
        }}
        width="inherit-parent-width"
        position="absolute-center-self-horizontally bottom-0 "
        maxWidth="none"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-fit-to-content"
      >
        <section
          data-cy="CLEAR-CACHE-CONFIRM-MODAL"
          className="font-color-tertiaryColor6 font-color-secondary text-align-center padding-larger background-color-primary"
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500"
            }}
            className="font-size-medium"
          >
            CLEAR CACHE
          </div>
          <div className="padding-top-default font-color-tertiaryColor5 font-size-small">
            Clearing cache will log you out. Log back in to get the latest app
            version and updates.
          </div>

          <section className="display-flex padding-top-larger ">
            <Button
              boxShadow={false}
              type="submit"
              variant="danger"
              text="CONFIRM"
              className="border-1px-e5e5e5 margin-right-small"
              onClick={() => {
                clearSiteCache();
                setModal({ ...modal, clearCache: false });
              }}
              data-cy="CONFIRM-CLEAR-CACHE-BUTTON"
            />
            <Button
              boxShadow={false}
              text="CANCEL"
              variant="transparent"
              onClick={() => {
                setModal({ ...modal, clearCache: false });
              }}
              className="padding-left-large padding-right-large"
              data-cy="CANCEL-CLEAR-CACHE-BUTTON"
            />
          </section>
        </section>
      </Modal>
    </div>
  );
}

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    profile: state.profile
  };
};

const mapDispatchToProps = function () {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);

function SectionDropdown(props) {
  return (
    <div
      style={{
        backgroundColor: props.isOpen
          ? "var(--tertiaryColor2)"
          : "var(--primaryColor)",

        opacity: props.blur ? "40%" : "100%",
        marginBottom: props.isOpen ? "16px" : "0px"
      }}
      className="padding-top-large padding-left-default padding-right-default padding-bottom-large"
    >
      <div
        className="display-flex flex-justify-content-space-between flex-align-items-center"
        onClick={props.onClick}
        data-cy={`section-dropdown-${props.title}`}
      >
        <div className="display-flex flex-align-items-center">
          {props.icon}
          <div className="margin-left-medium font-color-tertiaryColor6 font-size-small">
            {props.title}
          </div>
        </div>
        <div
          style={{
            width: "16px",
            height: "16px",
            transform: props.isOpen ? "rotate(-90deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease"
          }}
        >
          <ArrowIcon color="var(--tertiaryColor6)" />
        </div>
      </div>

      {props.isOpen && (
        <div className="margin-top-large margin-bottom-large">
          {props.children}
        </div>
      )}
    </div>
  );
}

// const ThemesContainer = (props) => {
//   const themesData = [
//     {
//       primaryColor: "#0E0E0E",
//       secondaryColor: "#20C74F",
//       secondaryColor1: "#0C2713",
//       tertiaryColor: "#FFFFFF",
//       tertiaryColor1: "#1C1C1C",
//       tertiaryColor2: "#262626",
//       tertiaryColor3: "#353535",
//       tertiaryColor4: "#3E3E3E",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#CFCFCF",
//       tertiaryColor7: "#ECECEC",
//       tertiaryColor8: "#212121",
//       tertiaryColor9: "#ffffff14"
//     },
//     {
//       primaryColor: "#0E0E0E",
//       secondaryColor: "#6EB3F4",
//       secondaryColor1: "#18232E",
//       tertiaryColor: "#FFFFFF",
//       tertiaryColor1: "#1C1C1C",
//       tertiaryColor2: "#262626",
//       tertiaryColor3: "#353535",
//       tertiaryColor4: "#3E3E3E",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#CFCFCF",
//       tertiaryColor7: "#ECECEC",
//       tertiaryColor8: "#212121",
//       tertiaryColor9: "#ffffff14"
//     },
//     {
//       primaryColor: "#0E0E0E",
//       secondaryColor: "#FFFFFF",
//       secondaryColor1: "#2F2F2F",
//       tertiaryColor: "#FFFFFF",
//       tertiaryColor1: "#1C1C1C",
//       tertiaryColor2: "#262626",
//       tertiaryColor3: "#353535",
//       tertiaryColor4: "#3E3E3E",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#CFCFCF",
//       tertiaryColor7: "#ECECEC",
//       tertiaryColor8: "#212121",
//       tertiaryColor9: "#ffffff14"
//     },
//     {
//       primaryColor: "#0E0E0E",
//       secondaryColor: "#9F5EEE",
//       secondaryColor1: "#20162D",
//       tertiaryColor: "#FFFFFF",
//       tertiaryColor1: "#1C1C1C",
//       tertiaryColor2: "#262626",
//       tertiaryColor3: "#353535",
//       tertiaryColor4: "#3E3E3E",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#CFCFCF",
//       tertiaryColor7: "#ECECEC",
//       tertiaryColor8: "#212121",
//       tertiaryColor9: "#ffffff14"
//     },
//     {
//       primaryColor: "#F3F3F3",
//       secondaryColor: "#0A9231",
//       secondaryColor1: "#CEE3D4",
//       tertiaryColor: "#0E0E0E",
//       tertiaryColor1: "#FFFFFF",
//       tertiaryColor2: "#FFFFFF",
//       tertiaryColor3: "#CFCFCF",
//       tertiaryColor4: "#AFAFAF",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#353535",
//       tertiaryColor7: "#262626",
//       tertiaryColor8: "#E1E1E1",
//       tertiaryColor9: "#00000014"
//     },
//     {
//       primaryColor: "#F3F3F3",
//       secondaryColor: "#4D8ECB",
//       secondaryColor1: "#D8E3ED",
//       tertiaryColor: "#0E0E0E",
//       tertiaryColor1: "#FFFFFF",
//       tertiaryColor2: "#FFFFFF",
//       tertiaryColor3: "#CFCFCF",
//       tertiaryColor4: "#AFAFAF",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#353535",
//       tertiaryColor7: "#262626",
//       tertiaryColor8: "#E1E1E1",
//       tertiaryColor9: "#00000014"
//     },
//     {
//       primaryColor: "#F3F3F3",
//       secondaryColor: "#0E0E0E",
//       secondaryColor1: "#CECECE",
//       tertiaryColor: "#0E0E0E",
//       tertiaryColor1: "#FFFFFF",
//       tertiaryColor2: "#FFFFFF",
//       tertiaryColor3: "#CFCFCF",
//       tertiaryColor4: "#AFAFAF",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#353535",
//       tertiaryColor7: "#262626",
//       tertiaryColor8: "#E1E1E1",
//       tertiaryColor9: "#00000014"
//     },
//     {
//       primaryColor: "#F3F3F3",
//       secondaryColor: "#874AD1",
//       secondaryColor1: "#E2D8EE",
//       tertiaryColor: "#0E0E0E",
//       tertiaryColor1: "#FFFFFF",
//       tertiaryColor2: "#FFFFFF",
//       tertiaryColor3: "#CFCFCF",
//       tertiaryColor4: "#AFAFAF",
//       tertiaryColor5: "#6E6E6E",
//       tertiaryColor6: "#353535",
//       tertiaryColor7: "#262626",
//       tertiaryColor8: "#E1E1E1",
//       tertiaryColor9: "#00000014"
//     }
//   ];

//   const findTheIndexOfThemeData = (data) => {
//     return themesData.findIndex(
//       (theme) =>
//         theme.primaryColor === data.primaryColor &&
//         theme.secondaryColor === data.secondaryColor
//     );
//   };

//   return (
//     <div
//       style={{
//         gap: "12px"
//       }}
//       className="display-flex flex-wrap flex-justify-content-center"
//     >
//       {themesData.map((data, i) => (
//         <div key={i} className="display-flex">
//           <DiagonalColorBox
//             selected={i === findTheIndexOfThemeData(props.selectedTheme)}
//             onThemeClick={props.onThemeClick}
//             data={data}
//           />
//         </div>
//       ))}
//     </div>
//   );
// };

// const DiagonalColorBox = (props) => {
//   return (
//     <div
//       onClick={() => {
//         props.onThemeClick(props.data);
//       }}
//       style={{
//         border: `2px solid ${
//           props.selected ? "var(--tertiaryColor)" : "var(--primaryColor)"
//         }`
//       }}
//     >
//       <div
//         className="margin-small"
//         style={{
//           width: "61px",
//           height: "32px",
//           position: "relative",
//           backgroundColor: props.data?.primaryColor
//         }}
//       >
//         <div
//           style={{
//             width: 0,
//             height: 0,
//             borderLeft: `20px solid ${props.data?.secondaryColor}`,
//             borderBottom: `20px solid transparent`,
//             position: "absolute"
//           }}
//         />
//       </div>
//     </div>
//   );
// };
